import React, { useState } from "react";
import {
  AppBar,
  makeStyles,
  Slide,
  Tab,
  Tabs,
  useScrollTrigger,
} from "@material-ui/core";

const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  navbar: {
    borderRadius: "0 0 10px 10px",
    backgroundColor: "#997DB5 !important",
  },
  tab: { textTransform: "none!important" },
}));

const ProductsNav = () => {
  const classes = useStyles();

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const HideOnScroll = (props) => {
    const { children } = props;
    const trigger = useScrollTrigger();

    return (
      <Slide appear={false} direction="down" in={!trigger}>
        {children}
      </Slide>
    );
  };

  return (
    <HideOnScroll>
      <AppBar className={classes.navbar} position="static" color="primary">
        <Tabs
          value={value}
          onChange={handleChange}
          centered
          className={classes.tab}
        >
          <Tab label="Decorativas" className={classes.tab} />
          <Tab label="Aromáticas" className={classes.tab} />
          <Tab label="Religiosas" className={classes.tab} />
          <Tab label="Repelentes" className={classes.tab} />
          <Tab label="Gift Sets" className={classes.tab} />
        </Tabs>
      </AppBar>
    </HideOnScroll>
  );
};

export default ProductsNav;
